import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { QUERY_KEY } from '~common';
import { getRequest } from '~services';
import { StationPricings } from '~types/pricing.type';

export const useQueryGetStationPricings = (
  reqParams: {
    serialNumberOrImei: string;
    paymentMethodId?: string;
  },
  options?: Omit<
    UseQueryOptions<
      StationPricings,
      AxiosError<Record<string, string>>,
      StationPricings,
      (QUERY_KEY | string)[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const getPricings = (): Promise<StationPricings> => {
    return getRequest({
      path: 'api/station/pricings',
      params: {
        ...reqParams,
        platform: 'WEB',
      },
    });
  };

  return useQuery(
    [
      QUERY_KEY.GET_STATION_PRICINGS,
      reqParams.serialNumberOrImei,
      reqParams.paymentMethodId ?? '',
    ],
    () => getPricings(),
    {
      ...options,
    },
  );
};
